<div fxLayout="row" style="margin-top: 15px; margin-bottom: 10px; margin-left: 10px; padding-left: 15px; padding-right: 15px;">
  <div fxFlex="50">
    <a mat-raised-button color="basic" (click)="returnBack()" style="margin-right: 10px;">Back</a>
  </div>
  <div fxFlex="50" class="text-right">

  </div>
</div>

<mat-card class="content-card">
    <app-file-upload *appHasRoles="'admin'" (upload)="onUpload($event)"></app-file-upload>
    <app-mat-table-generator #table
      tableName="sofortTransactionImportsTable"
      [columns]="importsCols"
      [dataSource]="dataSource"
      [multiselectEnabled]="multiselectEnabled()"
      [viewLink]="getViewLink"
      [useEmbededFilter]="false"
      [rowClassCallback]="getRowClass"
      [deleteEnabled]="deleteEnabled()"
      >
    </app-mat-table-generator>
</mat-card>
